// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_DESPATCH_DC_REQUEST = 'FETCH_DESPATCH_DC_REQUEST';
export const FETCH_DESPATCH_DC_SUCCESS = 'FETCH_DESPATCH_DC_SUCCESS';
export const FETCH_DESPATCH_DC_FAILURE = 'FETCH_DESPATCH_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_IN_DESPATCH_DC_REQUEST = 'FETCH_YARN_PO_IN_DESPATCH_DC_REQUEST';
export const FETCH_YARN_PO_IN_DESPATCH_DC_SUCCESS = 'FETCH_YARN_PO_IN_DESPATCH_DC_SUCCESS';
export const FETCH_YARN_PO_IN_DESPATCH_DC_FAILURE = 'FETCH_YARN_PO_IN_DESPATCH_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_DESPATCH_DC_REQUEST = 'CREATE_DESPATCH_DC_REQUEST';
export const CREATE_DESPATCH_DC_SUCCESS = 'CREATE_DESPATCH_DC_SUCCESS';
export const CREATE_DESPATCH_DC_FAILURE = 'CREATE_DESPATCH_DC_FAILURE';


// mm
//CREATE USER FORM
export const CREATE_USER_FORM_DESPATCH_DC = 'CREATE_USER_FORM_DESPATCH_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_DESPATCH_DC_REQUEST = 'UPDATE_DESPATCH_DC_REQUEST';
export const UPDATE_DESPATCH_DC_SUCCESS = 'UPDATE_DESPATCH_DC_SUCCESS';
export const UPDATE_DESPATCH_DC_FAILURE = 'UPDATE_DESPATCH_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_DESPATCH_DC_REQUEST = 'FETCH_SINGLE_DESPATCH_DC_REQUEST';
export const FETCH_SINGLE_DESPATCH_DC_SUCCESS = 'FETCH_SINGLE_DESPATCH_DC_SUCCESS';
export const FETCH_SINGLE_DESPATCH_DC_FAILURE = 'FETCH_SINGLE_DESPATCH_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_DESPATCH_DC_REQUEST = 'DELETE_DESPATCH_DC_REQUEST';
export const DELETE_DESPATCH_DC_SUCCESS = 'DELETE_DESPATCH_DC_SUCCESS';
export const DELETE_DESPATCH_DC_FAILURE = 'DELETE_DESPATCH_DC_FAILURE';

// USERFORM RESET

export const DESPATCH_DC_USERFORM_RESET = 'DESPATCH_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_DESPATCH_DC_DETAILS = 'NAVIGATE_DESPATCH_DC_DETAILS';
// navigate to company component
export const NAVIGATE_DESPATCH_DC = 'NAVIGATE_DESPATCH_DC';
export const DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_DESPATCH_DC_INVOICE_REQUEST = 'FETCH_DESPATCH_DC_INVOICE_REQUEST';
export const FETCH_DESPATCH_DC_INVOICE_SUCCESS = 'FETCH_DESPATCH_DC_INVOICE_SUCCESS';
export const FETCH_DESPATCH_DC_INVOICE_FAILURE = 'FETCH_DESPATCH_DC_INVOICE_FAILURE';

export const RESET_DESPATCH_DC_INVOICE = 'RESET_DESPATCH_DC_INVOICE';

export const HEADER_SEARCH_CALL_ONLOAD = "HEADER_SEARCH_CALL_ONLOAD";

export const SET_UNIT_NAME_DESPATCH_DC = 'SET_UNIT_NAME_DESPATCH_DC';

export const FETCH_DESPATCH_PO_IN_DESPATCH_DC_REQUEST = 'FETCH_DESPATCH_PO_IN_DESPATCH_DC_REQUEST';
export const FETCH_DESPATCH_PO_IN_DESPATCH_DC_SUCCESS = 'FETCH_DESPATCH_PO_IN_DESPATCH_DC_SUCCESS';
export const FETCH_DESPATCH_PO_IN_DESPATCH_DC_FAILURE = 'FETCH_DESPATCH_PO_IN_DESPATCH_DC_FAILURE';